import CheckBoxInput from 'components/elements/inputs/check-box-input';
import {
  isCheckedCheckboxTable,
  isIndeterminateCheckboxTable,
} from 'components/elements/table/utils';
import { useFormContext, useWatch } from 'react-hook-form';

import { HotelRescheduleDetailAddOnsFormType } from '../form-type';

interface HeaderCheckboxHotelRescheduleAddonsProps {
  index: number;
}
const name = 'hotelSales' as const;
export default function HeaderCheckboxHotelRescheduleAddons({
  index,
}: HeaderCheckboxHotelRescheduleAddonsProps) {
  const addOnsName = `${name}.${index}.hotelSaleAddOns` as const;
  const { setValue } = useFormContext();
  const addons: HotelRescheduleDetailAddOnsFormType[] = useWatch({
    name: addOnsName,
  });

  const isIndeterminate = isIndeterminateCheckboxTable({
    type: 'state',
    data: addons,
    isCheck(data) {
      return data.isSelected;
    },
  });

  const checked = isCheckedCheckboxTable({
    type: 'state',
    data: addons,
    isCheck(data) {
      return data.isSelected;
    },
  });

  return (
    <CheckBoxInput
      checked={checked}
      isIndeterminate={isIndeterminate}
      onChange={(e) => {
        const checked = e.currentTarget.checked;
        const _addons: HotelRescheduleDetailAddOnsFormType[] = addons.map(
          (addon) => {
            return {
              ...addon,
              isSelected: checked,
            };
          },
        );

        setValue(addOnsName, _addons, {
          shouldTouch: true,
          shouldValidate: true,
        });
      }}
    />
  );
}
